import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const hitsPerPage = 10;

export const resultAttributes = [
  'comment_id',
  'comment_created',
  'comment_changed',
  'comment_message',
  'comment_message_processed',
  'comment_author_id',
  'comment_author_nickname',
  'comment_author_avatar',
  'comment_post_id',
  'comment_like_count',
  'comment_like_uids',
  'comment_inappropriate_uids',
  'parent_comment_id',
  'parent_comment_author_id',
  'parent_comment_author_nickname',
  'parent_comment_link',
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: 'comment_created',
    order: 'asc',
  },
};
